// This file is a temporary effort that strays from the current convention of
// the project by introducing the ducks pattern. This bundles all branch related
// utilities into one module

const upgradePageViewInitialState = {
  isPricingPageInitializationComplete: false
};
export const PRICING_PAGE_INITIALIZATION_COMPLETED = 'PRICING_PAGE_INITIALIZATION_COMPLETED';
export const hydrateUpgradePageContext = () => {
  return {
    type: PRICING_PAGE_INITIALIZATION_COMPLETED,
    payload: true
  };
};
export const upgradePageViewReducer = (state = upgradePageViewInitialState, action) => {
  switch (action.type) {
    case PRICING_PAGE_INITIALIZATION_COMPLETED:
      {
        return {
          isPricingPageInitializationComplete: action.payload
        };
      }
    default:
      return state;
  }
};
export const selectIsPricingPageInitializationComplete = state => {
  return state.upgradePageView.isPricingPageInitializationComplete;
};